export const addCookie = (name, value, date) => {
  if (!date) date = new Date();
  date.setDate(date.getDate() + 30);
  const UTCString = date.toUTCString();
  document.cookie = `${name}=${value};expires=${UTCString};sameSite=strict;`;
};

export const addAllCookies = obj => {
  const date = new Date();
  Object.keys(obj).forEach(key => {
    console.log(key)
    addCookie(key, obj[key], date);
  });
};

export const getCookie = name => {
  const cookie = document.cookie.split(';').find(item => item.startsWith(name));
  if (!cookie) return null;
  const value = cookie.split('=')[1];
  return value;
};

export const getAllCookies = () => {
  const cookiesObj = {};
  const cookies = document.cookie;
  if (!cookies) return;
  cookies.split(';').forEach(item => {
    const [key, value] = item.trim().split('=');
    cookiesObj[key] = value;
  });
  return cookiesObj;
};

export const deleteCookie = name => {
  document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;';
};

export const deleteAllCookies = () => {
  const cookies = document.cookie.split(';');
  cookies.forEach(cookie => {
    const cookieName = cookie.trim().split('=')[0];
    document.cookie = deleteCookie(cookieName);
  });
  document.cookie = 'undefined;expires=Thu, 01 Jan 1970 00:00:00 GMT;';
};



// WEBPACK FOOTER //
// ./src/utilities/cookie.js